<template>
    <div
		class="rp-basic-card rp-start-new-conversation-widget rp-home-screen-card" :class="loading? 'loading': 'after-loading'"
		v-loading="loading"
		>
		<el-collapse-transition>
			<div v-if="!loading" class="rp-start-new-conversation-widget__wrapper">
				<div class="rp-start-new-conversation-widget__header rp-messenger-widget-content-header"> 
					<div>{{ conversations.length ? $t('homeScreen.recentConversations') :  helpAndSupportLabel }}</div>
				</div>
				<template v-if="conversations && conversations.length">
					<div class="rp-start-new-conversation-widget__prev-conv">
						<ConversationListItem
							class="animated slideInUp padding-20px"
							v-for="(conversation, index) in conversations"
							:key="conversation.id"
							:conversation="conversation"
							:style="{ animationDuration: (index+1)*0.2 + 's' }"
							@click="handleConversationListItemClick(conversation)"
						/>
					</div>
				</template>
				<template v-else>
					<AgentsInfo
						:replyTimeLabel="replyTimeLabel"
						:teamToRespond="teamToRespond"
						:nextAvailableBusinessHours="nextAvailableBusinessHours"
						class="rp-start-new-conversation-widget__content"
					/>
				</template>
				<div class="rp-start-new-conversation__footer-actions">
					<el-button 						
						v-if="conversations && conversations.length"
 						type="text"
						@click="clickedOnStartConversation"
						class="rp-messenger-conversation-new-message-label"
					>	
						{{ $t('homeScreen.newMessageButton') }}
					</el-button>
					<StartConversationButton
						v-else
						:buttonType="helpcenterStatus ? 'outline' : 'filled'"
						:label="helpcenterStatus ? $t('homeScreen.newConversationButton') : $t('homeScreen.sendUsMessage')"
						@click="clickedOnStartConversation"
						class="rp-start-new-conversation__button"
					/>
					<div class="rp-messenger-view-all-conversations"
						v-if="conversationsLength > 2"
					>	<el-badge class="all-chats-badge" :hidden="notificationCount<=0" :value="notificationCount">
							<button
								class="see-all-btn"
								@click="$emit('onViewAllButtonClick')">
								{{ $t('homeScreen.allChatsButton') }}
							</button>
						</el-badge>
					</div>
				</div>
			</div>
		</el-collapse-transition>
	</div>
</template>

<script>
// import LineLoader from './LineLoader'
import StartConversationButton from './StartConversationButton'
import ConversationListItem from './ConversationListItem'
import AgentsInfo from './AgentsInfo'
import { mapActions, mapGetters } from 'vuex';
export default {
	props: {

		replyTimeLabel: {
			type: String,
			required: true
		},

		loading: {
			type: Boolean,
			default: false
		},

		teamToRespond: {
			type: String,
			required: true,
		},

		nextAvailableBusinessHours: {
			type: String,
			required: true,
		},

		helpAndSupportLabel: {
			type: String,
			required: false,
		},

		helpcenterStatus: {
			type: Boolean,
			default: false,
		},

		conversations: {
			type: Array,
			default: () => []
		},

		notificationCount: {
			type: Number,
			default: 0
		},

		conversationsLength: {
			type: Number,
			default: 0
		},

	},

	components: {
		StartConversationButton,
		AgentsInfo,
		ConversationListItem,
	},
	methods: {

		clickedOnStartConversation() {
			this.$emit('onNewConversationButtonClick')
		},

		async handleConversationListItemClick(conversation){
			await this.SET_SELECTED_CONVERSATION(conversation)
			this.$emit('onConversationClick', conversation)
		},

		...mapActions({
			SET_SELECTED_CONVERSATION:'SET_SELECTED_CONVERSATION'
		})
	},
}
</script>

<style lang="scss">
.rp-start-new-conversation-widget {
	margin: 16px;
	@include flexFullCenterColumn;
	overflow: hidden;
	flex-basis: 60%;
	align-items: flex-start;
	min-height: 100px;
	.rp-start-new-conversation-widget__wrapper {
		width: 100%;
		.rp-start-new-conversation-widget__prev-conv{
			padding: 0px 20px;
			@include for-size(tablet-landscape-up) {
				padding: 0px 40px;
			}
			@include for-size(desktop-up){
				padding: 0px 60px;
			}
		}
	}
	.rp-start-new-conversation-widget__content {
		align-items: flex-start;
		margin-bottom: 0px;
		padding: 0px 20px;
		@include for-size(tablet-landscape-up) {
			padding: 0px 40px;
		}
		@include for-size(desktop-up){
			padding: 0px 60px;
		}
	}
	.rp-start-new-conversation__footer-actions {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 18px 20px;
		@include for-size(tablet-landscape-up) {
			padding: 20px 40px 30px;
		}
		@include for-size(desktop-up){
			padding: 20px 60px 30px;
			.el-button {
				padding: 0px;
			}
		}
		.rp-messenger-conversation-new-message-label {
			color: #333;
			padding: 0px;
			line-height: 1.2;
			@include for-size(tablet-landscape-up) {
				font-size: 18px;
			}
		}
		.rp-start-new-conversation__button {
			text-transform: uppercase;
			padding: 0.55rem 1rem;
		}
		.see-all-btn {
			color: #333;
			line-height: 1.2;
			padding: 0px 2px;
			margin-right: -2px;
		}
	}
}

</style>
